import React from 'react';
import PropTypes from 'prop-types';

const Footer = ({ children }) => (
  <div id="footer" className="flex-row flex--centered">
    <span>
      Made with <span style={{ color: '#d0c504' }}>&#9829;</span> by <a href="http://i4.com.tr/">i4</a>
    </span>
    {children}
  </div>
);

Footer.propTypes = {
  children: PropTypes.array,
};

Footer.defaultProps = {
  children: null,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js